import { useEffect } from 'react';
import { setNavigateFunction } from '../utils/api';

/**
 * API Provider 组件 - 为API工具类提供导航功能
 * 这个组件应该在应用的最顶层使用，确保所有页面都能使用401自动跳转功能
 */
const ApiProvider = ({ children, navigate }) => {
  useEffect(() => {
    // 设置导航函数到API工具类
    setNavigateFunction(navigate);

    // 清理函数（组件卸载时）
    return () => {
      setNavigateFunction(null);
    };
  }, [navigate]);

  // 这个组件只负责提供导航功能，不渲染任何UI
  return children;
};

export default ApiProvider;